import React from "react";
// import "../css/style.css";
import "../Css/style.css";
import { DialogDefault } from "./Dialog";

export default function Hero() {
 
  return (
    <>
      <section className="hero-section " id="hero">
        <div className="wave">
          <svg
            width="100%"
            height="355px"
            viewBox="0 0 1920 355"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="Apple-TV"
                transform="translate(0.000000, -402.000000)"
                fill="#FFFFFF"
              >
                <path
                  d="M0,439.134243 C175.04074,464.89273 327.944386,477.771974 458.710937,477.771974 C654.860765,477.771974 870.645295,442.632362 1205.9828,410.192501 C1429.54114,388.565926 1667.54687,411.092417 1920,477.771974 L1920,757 L1017.15166,757 L0,757 L0,439.134243 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </svg>
        </div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 hero-text-image">
              <div className="row px-5 mdpx-3">
                <div className="col-lg-6 text-center text-lg-start d-flex justify-content-center  flex-column">
                  <h1 data-aos="fade-right">
                    Your Ultimate Task Management Solution
                  </h1>
                  <p
                    className="mb-3"
                    data-aos="fade-right"
                    data-aos-delay="100"
                  >
                    Effortlessly conquer your to-do list with TaskHero. Our
                    intuitive task management platform is designed to
                    supercharge your productivity, making every day a triumph.
                  </p>
                  <p
                    data-aos="fade-right"
                    data-aos-delay="200"
                    data-aos-offset="-500"
                    className="my-5"
                  >
                    <a href="/" className="btn btn-outline-white">
                      Get started
                    </a>
                  </p>
                </div>
                <div className="col-lg-6 iphone-wrap">
                  {/* <img
                  src="https://i.postimg.cc/bv192nfm/output-onlinegiftools.gif"
                  alt="Image"
                  className="phone-2"
                  data-aos="fade-right"
                  data-aos-delay="200"
                /> */}

                  <dotlottie-player
                    src="https://lottie.host/bf72264f-5275-4619-b210-aeda8c183077/1ABCOwhkfr.json"
                    background="transparent"
                    speed="1"
                    loop
                    autoplay
                  ></dotlottie-player>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="about section-padding prelative"
        data-scroll-index="1"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="sectioner-header text-center">
                <h3>About</h3>
                <span className="line"></span>
                <p>
                  Sed quis nisi nisi. Proin consectetur porttitor dui sit amet
                  viverra. Fusce sit amet lorem faucibus, vestibulum ante in,
                  pharetra ante.
                </p>
              </div>
              <div className="section-content text-center">
                <div className="row">
                  <div className="col-md-4">
                    <div
                      className="icon-box wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      {" "}
                      <i className="fa fa-life-ring" aria-hidden="true"></i>
                      <h5>Support</h5>
                      <p>
                        Phasellus lobortis justo a magna facilisis, in commodo
                        tellus rutrum. Sed vitae condimentum nulla.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className="icon-box wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      {" "}
                      <i className="fa fa-mobile" aria-hidden="true"></i>
                      <h5>Cross Platform</h5>
                      <p>
                        Phasellus lobortis justo a magna facilisis, in commodo
                        tellus rutrum. Sed vitae condimentum nulla.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className="icon-box wow fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      {" "}
                      <i className="fa fa-bolt" aria-hidden="true"></i>
                      <h5>Fast</h5>
                      <p>
                        Phasellus lobortis justo a magna facilisis, in commodo
                        tellus rutrum. Sed vitae condimentum nulla.
                      </p>
                    </div>
                  </div>
                </div>
                <a href="#" className="about-btn">
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="video-section prelative text-center white">
        <div className="section-padding video-overlay">
          <div className="container">
            <h3>Watch Now</h3>
            <DialogDefault />
            
          </div>
        </div>
      </section>
      <section className="feature section-padding" data-scroll-index="2">
        <div className="px-5">
          <div className="row">
            <div className="col-md-12">
              <div className="sectioner-header text-center">
                <h3>Features</h3>
                <span className="line"></span>
                <p>
                  Sed quis nisi nisi. Proin consectetur porttitor dui sit amet
                  viverra. Fusce sit amet lorem faucibus, vestibulum ante in,
                  pharetra ante.
                </p>
              </div>
              <div className="section-content text-center">
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div
                      className="media flex  single-feature wow fadeInUp my-5"
                      data-wow-delay="0.2s"
                    >
                      <div className="media-body text-right media-right-margin">
                        <h5>Fast Processing</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing{" "}
                        </p>
                      </div>
                      <div className="media-right icon-border">
                        {" "}
                        <span
                          className="fa fa-bolt"
                          aria-hidden="true"
                        ></span>{" "}
                      </div>
                    </div>
                    <div
                      className="media flex single-feature wow my-5 fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <div className="media-body text-right media-right-margin">
                        <h5>Low Power Consuming</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididugnt ut labore
                        </p>
                      </div>
                      <div className="media-right icon-border">
                        {" "}
                        <span
                          className="fa fa-battery-full"
                          aria-hidden="true"
                        ></span>{" "}
                      </div>
                    </div>
                    <div
                      className="media flex single-feature wow my-5 fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      <div className="media-body text-right media-right-margin">
                        <h5>Wifi Compatibility</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididugnt ut labore
                        </p>
                      </div>
                      <div className="media-right icon-border">
                        {" "}
                        <span
                          className="fa fa-wifi"
                          aria-hidden="true"
                        ></span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 d-none d-md-block d-lg-block h-full">
                    <div className="feature-mobile h-full">
                      {" "}
                      <img
                        src="https://i.postimg.cc/90YfwnV7/65968-removebg-preview.png"
                        className="img-fluid wow fadeInUp h-full"
                      />{" "}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div
                      className="media flex single-feature my-5 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div className="media-left icon-border media-right-margin">
                        {" "}
                        <span
                          className="fa fa-check-double"
                          aria-hidden="true"
                        ></span>{" "}
                      </div>
                      <div className="media-body text-left">
                        <h5>Regular Updates</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididugnt ut labore
                        </p>
                      </div>
                    </div>
                    <div
                      className="media flex single-feature my-5 wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <div className="media-left icon-border media-right-margin">
                        {" "}
                        <span
                          className="fa fa-dollar-sign"
                          aria-hidden="true"
                        ></span>{" "}
                      </div>
                      <div className="media-body text-left">
                        <h5>Save Money</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididugnt ut labore
                        </p>
                      </div>
                    </div>
                    <div
                      className="media flex single-feature  my-5 wow fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      <div className="media-left icon-border media-right-margin">
                        {" "}
                        <span
                          className="fa fa-hdd"
                          aria-hidden="true"
                        ></span>{" "}
                      </div>
                      <div className="media-body text-left">
                        <h5>Unlimited Storage</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididugnt ut labore
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </>
  );
}
